export const MATCHINGPROFILE = 'MATCHINGPROFILE'
export const REQUIREMENTPROFILE = 'REQUIREMENTPROFILE'
export const TALENTPROFILE = 'TALENTPROFILE'
export const TEAMPROFILE = 'TEAMPROFILE'
export const CROSSCOMPARISON = 'CROSSCOMPARISON'
export const CAREERSMATCHING = 'CAREERSMATCHING'
